import styled from 'styled-components';

import { TEXT } from 'constants/colors';

export default styled.div`
  .header {
    margin-bottom: 10px;
    line-height: 32px;

    .quarter {
      padding: 0 10px;
    }

    > div {
      width: 33%;
    }

    .compare-with {
      margin-right: 20px;
    }
  }

  .settings {
    width: 205px;
    padding-right: 20px;
    flex-shrink: 0;

    .group-row {
      margin-bottom: 14px;
    }

    .MuiFormGroup-root {
      margin-left: 5px;
    }

    .MuiInputLabel-root,
    .MuiInput-root {
      font-size: 13px;
    }

    h3 {
      margin: 0 0 1.3em 0 !important;
    }
  }

  .main {
    flex-grow: 1;
  }

  .chart-wrapper {
    width: 100%;
    height: 400px;
    padding-right: 20px;
    box-sizing: border-box;
  }

  .analyzer-table {
    table-layout: fixed;

    th,
    td {
      text-align: center;
    }

    th:first-child,
    td:first-child {
      width: 172px;
      box-sizing: border-box;
      text-align: left;
    }

    th:last-child,
    td:last-child {
      width: 105px;
      box-sizing: border-box;
      text-align: right;
    }

    .padd-cell {
      padding-left: 32px;
    }

    .bullet {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      display: inline-block;
      margin-right: 8px;
    }

    .anchor-btn {
      display: flex;
      gap: 0 8px;
      align-items: center;
      font-weight: 400;
      color: ${TEXT};
    }
  }
`;
